import { ClinicFromList } from '../Clinics/types';
import { ClinicSelectorOption } from './interface';

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function getSelectedOption(selectedClinicsId: string, clinics: ClinicFromList[]) {
  const selectedClinics = findSelectedClinicsById(clinics, selectedClinicsId);

  return selectedClinics.map(createOption);
}

function findSelectedClinicsById(clinics: ClinicFromList[], selectedClinicsId: string) {
  return clinics.filter(clinic => clinic._id === selectedClinicsId);
}

export function createOptions(questionnaires: ClinicFromList[], selectedClinic?: ClinicFromList | null) {
  const options: ClinicSelectorOption[] = [createEmptyOption()];

  if (selectedClinic) {
    options.push(createOption(selectedClinic));
  }

  return options.concat(mapClinicsToOptions(questionnaires));
}

function mapClinicsToOptions(clinics: ClinicFromList[]): ClinicSelectorOption[] {
  return clinics.map(createOption);
}

function createOption(clinic: ClinicFromList): ClinicSelectorOption {
  return {
    value: clinic._id,
    label: clinic.name
  };
}

function createEmptyOption(): ClinicSelectorOption {
  return {
    value: null,
    label: 'None'
  };
}
